@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!isLoading) {
  <div class="md:px-3 lg:px-28 pt-4 bg-white h-full px-4">
    <div class="pt-4 py-2 lg:px-28">
      <button class="gap-2 flex items-center" routerLink='/parkifly/handle-booking'>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-6 stroke-[#0D6EFD]">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
        <p class="font-medium text-sm text-[#0D6EFD]">{{ "PARKIFLY.BACK_BUTTONS.BACK_TO_START" | transloco }}</p>
      </button>
    </div>
    <div class="Content w-full lg:px-28 px:10 justify-end items-start gap-8  flex xl:flex-row flex-col ">
      <div class="Frame808 flex-col justify-start items-start gap-4 inline-flex w-full">
        <div class="Frame802 self-stretch flex-col justify-start items-start gap-4 flex">
          <div class="DinaUppgifter text-black text-xl font-medium  leading-loose">{{'PARKIFLY.HOME.MANAGE_BOOKING_FOR' |
            transloco}} <span class="font-bold">{{this.bookingNumber}}</span></div>
            <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
              <div class="Frame800 self-stretch justify-start items-start flex flex-col lg:flex-row ">
                @if(this.handleBookingGroup.controls.firstname){
                  <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full ">
                    <div
                      class="Frame793 grow bg-[#fafafa] rounded-tl-2xl shrink basis-0 pt-3 h-20 lg:border-r border-b border-zinc-200 justify-start items-start gap-2.5 flex">
                      <pf-text-input icon="envelope" iconColor="fill-[#9CA3AF]"
                        label="{{'PARKIFLY.FORM.FIRST_NAME' | transloco}}"
                      [inputFormControl]="this.handleBookingGroup.controls.firstname" class="w-full"></pf-text-input>
                    </div>
                  </div>
                }
                @if(this.handleBookingGroup.controls.lastname){
                  <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
                    <div
                      class="Frame793 grow bg-[#fafafa] rounded-tr-2xl shrink basis-0 h-20 pt-3  border-b border-zinc-200 justify-start items-start gap-2.5 flex">
                      <pf-text-input label="{{'PARKIFLY.FORM.LAST_NAME' | transloco}}"
                        [inputFormControl]="this.handleBookingGroup.controls.lastname"
                      class="w-full focus:ring-0">></pf-text-input>
                    </div>
                  </div>
                }
              </div>
              <div class="Frame800 self-stretch justify-start items-start flex flex-col lg:flex-row ">
                <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex w-full ">
                  <div
                    [ngClass]="{'border-b border-zinc-200' : this.handleBookingGroup.controls.comment, 'rounded-bl-2xl' : !this.handleBookingGroup.controls.comment, 'rounded-tl-2xl' : !this.handleBookingGroup.controls.firstname}"
                    class="Frame793 grow bg-[#fafafa] shrink basis-0 pt-3 h-20 lg:border-r justify-start items-start gap-2.5 flex">
                    <pf-email-input-field icon="envelope" iconColor="fill-[#9CA3AF]"
                      label="{{'PARKIFLY.FORM.EMAIL' | transloco}}"
                    [inputFormControl]="this.handleBookingGroup.controls.email" class="w-full"></pf-email-input-field>
                  </div>
                </div>
                <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
                  <div [ngClass]="{'border-b border-zinc-200' : this.handleBookingGroup.controls.comment}"
                    class="Frame793 grow shrink basis-0 h-20 pt-3 justify-start items-start gap-2.5 flex">
                    <pf-phone-number-input label="{{'PARKIFLY.FORM.PHONENUMBER' | transloco}}"
                      [inputFormControl]="this.handleBookingGroup.controls.cellular"
                    class="w-full focus:ring-0">></pf-phone-number-input>
                  </div>
                </div>
              </div>
              @if(this.handleBookingGroup.controls.comment) {
                <div class="Frame801 self-stretch justify-start items-start inline-flex">
                  <div class="Frame795 grow shrink basis-0 h-20 justify-start items-start flex">
                    <div
                      class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                      <pf-text-input label="{{'PARKIFLY.FORM.COMMENT' | transloco}}"
                        [inputFormControl]="this.handleBookingGroup.controls.comment"
                      class="w-full focus:ring-0"></pf-text-input>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          @if(this.handleBookingGroup.controls.persons) {
            <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
              <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
                {{'PARKIFLY.DETAILS.YOU_AND_COMPANY' |
              transloco}}</div>
              <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
                <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
                  <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
                    <div
                      class="Frame793 grow shrink basis-0 pt-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
                      <pf-select label="{{'PARKIFLY.FORM.PERSONS' | transloco}}"
                        [inputFormControl]="this.handleBookingGroup.controls.persons" [options]="passengers"
                      class="w-full"></pf-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if(this.handleBookingGroup.controls.arrivalTimeAtParking) {
            <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
              <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">{{
              'PARKIFLY.SEARCH.ARRIVAL_TIME' | transloco}}</div>
              <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
                <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
                  <div class="Frame793 grow shrink basis-0 pt-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
                    <pf-select [label]="'PARKIFLY.MANAGE_BOOKING.ARRIVAL_TIME' | transloco"
                      [inputFormControl]="this.handleBookingGroup.controls.arrivalTimeAtParking" class="w-full"
                    [options]="this.arrivalParkingOptions"></pf-select>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex">
            <div class="Biluppgifter text-black text-xl font-medium  leading-loose">{{'PARKIFLY.DETAILS.CAR_DETAILS' |
              transloco}}
            </div>
            <div class="Bagage self-stretch  rounded-xl border border-neutral-300 justify-start items-end inline-flex">
              <div class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input (input)="regToUpper()" label="{{'PARKIFLY.FORM.CARID' | transloco}}"
                [inputFormControl]="this.handleBookingGroup.controls.regNr" class="w-full"></pf-text-input>
              </div>
            </div>
          </div>
          <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
            @if(this.handleBookingGroup.controls.contact) {
              <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
                {{'PARKIFLY.MANAGE_BOOKING.CONTACT_US' |
              transloco}}</div>
              <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
                <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
                  <div
                    class="Frame793 grow shrink basis-0 pt-3 pl-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
                    <app-radio-btn class="margin-top-neg-15px" [inputFormControl]="this.handleBookingGroup.controls.contact"
                      [options]="[{ value: 'true', viewValue: 'PARKIFLY.MANAGE_BOOKING.YES' | transloco }, { value: 'false', viewValue: 'PARKIFLY.MANAGE_BOOKING.NO' | transloco }]"
                    value="false"></app-radio-btn>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <!-- booking summary -->
        <div class="flex-col basis-1/3 w-full">
          <app-booking-summary-card [bookingDetails]="bookingDetails" [booking]="booking"></app-booking-summary-card>
        </div>
      </div>
      <div class="md:pt-8">
        <div class="pt-4 pb-8 lg:px-28 md:px-0 md:pt-8 md:flex md:justify-start md:flex-row-reverse gap-2">
          @if(booking.orderStatus && booking.orderStatus == "Checkout") {
            <button
              class="w-full px-8 py-3 bg-[#FFC700] hover:bg-[#FFD833] rounded-[4px] font-semibold text-sm leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0"
              (click)="goToPaymentPage()">
              {{ 'PARKIFLY.MANAGE_BOOKING.COMPLETE_PAYMENT' | transloco }}
            </button>
          }
          <button
            class="w-full px-8 py-3 bg-[#FFC700] hover:bg-[#FFD833] rounded-[4px] font-semibold text-sm leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0"
            (click)="updateBooking()">
            {{ 'PARKIFLY.MANAGE_BOOKING.UPDATE_BOOKING' | transloco }}
          </button>
          <button
            class="w-full px-8 py-3 bg-[#FFC700] hover:bg-[#FFD833] rounded-[4px] font-semibold text-sm leading-6 flex justify-center md:mb-0 md:w-auto mb-4 mr-1 md:mb-0"
            (click)="(downloadPdf())" [disabled]="!bookingLoaded">
            <div class="mr-2">
              {{
              "PARKIFLY.CONFIRMATION.DOWNLOAD_AS_PDF" | transloco }}
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5">
              <path
                d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
              <path
                d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
            </svg>
          </button>
          @if(booking?.parkingStatus && booking?.parkingStatus !== "Checkin") {
            <button
              class="w-full px-8 py-3 rounded-[4px]  font-bold text-sm leading-6 flex justify-center cancel-button md:w-auto mb-4 md:mb-0"
              (click)="openConfirmModal()">
              {{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_PARKING' | transloco }}
            </button>
          }
          @if(bookingDetails.additionalServices && bookingDetails.additionalServices.length) {
            <button
              class="w-full px-8 py-3 rounded-[4px]  font-bold text-sm leading-6 flex justify-center cancel-button md:w-auto mb-4 md:mb-0"
              (click)="openModalConfirmServiceCancel()">
              {{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_SERVICES' | transloco }}
            </button>
          }
        </div>
      </div>
    </div>
  }